module.exports = __webpack_public_path__ + "media/images/newsletter/new-newsletter-bg-ff32e2c353276f61f35319749e53f594.png";